import { AfterContentInit, ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { EVENT } from 'src/app/shared/constants/dali.constants';
import { FinancialModel } from 'src/app/shared/models/abre-cuentas.model';
import { Changes, TagEvent } from 'src/app/shared/models/dali-tags.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';

@Component({
  selector: 'app-expenses-form',
  templateUrl: './expenses-form.component.html',
  styleUrls: ['./expenses-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpensesFormComponent implements OnInit, AfterContentInit {
  formGroup: FormGroup;
  financialInfo: FinancialModel;
  reactiveError: string;
  activeInput = false;
  selected: any;

  config = {
    allowNegative: false,
    decimal: ',',
    precision: 0,
    thousands: '.',
    prefix: '$ ',
  };

  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private formBuilder: FormBuilder,
    public abreCuentasService: AbreCuentasService,
    private navigationService: NavigationService,
    private taggingService: TaggingService,
  ) {
    this.headerService.show(true, true, true);
    this.formGroup = this.formBuilder.group({
      expenses: new FormControl('', [Validators.required, Validators.min(100000), Validators.max(999999999999)]),
      expensesdiscount: new FormControl('', [Validators.min(0), Validators.max(999999999999)]),
    });
  }

  ngOnInit() {
    this.financialInfo = this.abreCuentasService.getFinancialInfo();
    if (!this.abreCuentasService.viewOptionMultiProduct) {
      this.formGroup.controls['expenses'].setValidators([Validators.required, Validators.min(10000), Validators.max(999999999999)]);
      this.formGroup.controls['expenses'].updateValueAndValidity();
    }
    if (this.abreCuentasService.haveLoan) {
      this.formGroup.controls['expensesdiscount'].setValidators([Validators.required, Validators.min(0), Validators.max(999999999999)]);
      this.formGroup.controls['expensesdiscount'].updateValueAndValidity();
    }
    this.activeInput = this.financialInfo.expenses !== undefined && this.financialInfo.expenses !== 0;
  }

  ngAfterContentInit() {
    const controlexpenses = this.formGroup.controls['expenses'] as FormControl;
    controlexpenses.setValue(Math.trunc(this.financialInfo.expenses));
    const controlExpensesDiscount = this.formGroup.controls['expensesdiscount'] as FormControl;
    controlExpensesDiscount.setValue(Math.trunc(this.financialInfo.expensesDiscount || 0));
  }

  /**
   * Summary Set validators to expenses Control
   * @param event
   */
  reactiveInputChangeExpenses() {
    if (this.abreCuentasService.viewOptionMultiProduct) {
      if (!this.activeInput) {
        return;
      }
      try {
        const controlExpenses = this.formGroup.controls['expenses'] as FormControl;
        let valor = this.formGroup.controls['expenses'].value
          ? this.formGroup.controls['expenses'].value : '';
        // Erase this comment if the new input component requires this validation
        // valor = valor.replace('$ ', '').split(/\./).join('');
        this.reactiveError = controlExpenses.valid ? '' : 'Gastos mínimos $10.000 COP';
        if (!isNaN(+ valor) && + valor > 100000) {
          this.reactiveError = '';
          return;
        }
        // When the input has number validation, it never gets into this if block
        if (isNaN(+ valor)) {
          this.reactiveError = 'Este valor deber ser mayor a $100.000 (el monto máximo permitido será $999.999.999.999.99)';
          valor = valor.substring(0, valor.length - 1);
          if (!isNaN(+ valor) && + valor > 100000) {
            this.reactiveError = '';
          }
          return;
        }
        if (+ valor === 0) {
          this.reactiveError = 'El valor diligenciado deberá ser mayor $0.';
          return;
        }
        /* istanbul ignore next */
        if (+ valor < 100000) {
          this.reactiveError = 'Este valor deber ser mayor a $100.000 (el monto máximo permitido será $999.999.999.999.99)';
          return;
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      if (!this.activeInput) {
        return;
      }
      try {
        const controlExpenses = this.formGroup.controls['expenses'] as FormControl;
        let valor = this.formGroup.controls['expenses'].value
          ? this.formGroup.controls['expenses'].value : '';
        // Erase this comment if the new input component requires this validation
        // valor = valor.replace('$ ', '').split(/\./).join('');
        this.reactiveError = controlExpenses.valid ? '' : 'Gastos mínimos $10.000 COP';
        if (!isNaN(+ valor) && + valor >= 10000) {
          this.reactiveError = '';
          return;
        }
        // When the input has number validation, it never gets into this if block
        if (isNaN(+ valor)) {
          this.reactiveError = 'Gastos mínimos $10.000 COP';
          valor = valor.substring(0, valor.length - 1);
          if (!isNaN(+ valor) && + valor >= 10000) {
            this.reactiveError = '';
          }
          return;
        }
        /* istanbul ignore next */
        if (+ valor < 10000) {
          this.reactiveError = 'Gastos mínimos $10.000 COP';
          return;
        }
      } catch (error) {
        console.log(error);
      }
    }
  }

  /**
   *  Summary Handles the onFocus event
   */
  reactiveOnFocus() {
    this.activeInput = true;
  }

  /**
   * Summary sending next screen and set data for model in financial Info
   */
  next() {
    // Check if this validations are required in the new component
    // let expenses: string = this.formGroup.controls['expenses'].value.replace('$ ', '').split(/\./).join('');
    // expenses = expenses.replace(/[^\d]/, '');
    this.financialInfo.expenses = Math.trunc(this.formGroup.controls['expenses'].value);
    this.financialInfo.incomes_input = 0;
    this.financialInfo.next = false;
    this.financialInfo.expensesDiscount = Math.trunc(this.formGroup.controls['expensesdiscount'].value);
    this.abreCuentasService.setFinancialInfo(this.financialInfo);
    this.pageTagEvent();
    // this.navigationService.nextStep(this.abreCuentasService.getPageZoneGray());
    if (this.abreCuentasService.viewOptionMultiProduct) {
      if (this.abreCuentasService.isGrayZone()) {
        this.navigationService.nextStep('202');
      } else {
        this.navigationService.nextStep('201');
      }
    } else {
      this.navigationService.nextStep('200');
    }

  }

  pageTagEvent() {
    const tagPageName = this.navigationService.getCurrentStep().tag_name;
    try {
      const changes: Changes[] = [
        {
          path: EVENT[`${tagPageName}E1setData`][`${tagPageName}E1transactionName`].path,
          value: EVENT[`${tagPageName}E1setData`][`${tagPageName}E1transactionName`].value,
        },
        {
          path: EVENT[`${tagPageName}E1setData`][`${tagPageName}E1transactionDetailsProductcategory`].path,
          value: EVENT[`${tagPageName}E1setData`][`${tagPageName}E1transactionDetailsProductcategory`].value,
        },
      ];
      const event: TagEvent = {
        category: {
          module: EVENT.customCategory.module.body,
          type: EVENT.customCategory.type.button,
          position: EVENT.customCategory.position.bottom,
        },
        action: EVENT.customAction.click,
        label: EVENT[`${tagPageName}E1customLabel`] + `${this.financialInfo.expenses}`,
      };
      this.taggingService.pageTagEvent(event, changes);
    } catch (err) {
      console.log(err);
    }
  }
}
